require("./global/global");
require("./registration-page-1/index");